import template from './sw-cms-el-preview-acris-faq.html.twig';
import './sw-cms-el-preview-acris-faq.scss';

const { Component } = Shopware;

Component.register('sw-cms-el-preview-acris-faq', {
    template
});
